import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PipeGroupModel } from '../../../models/dictionaries/pipe-group.model';
declare var $: any;

@Component({
  selector: 'app-pipe-groups-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPipeGroup.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Code:</span>
                                    <input type="text" [(ngModel)]="editedPipeGroup.code" formControlName="code">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="editedPipeGroup.description" formControlName="description">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="saveNewPipeGroup()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedPipeGroup.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Code:</span>
                                    <input type="text" [(ngModel)]="editedPipeGroup.code" formControlName="code">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="editedPipeGroup.description" formControlName="description">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="editPipeGroup()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Pipe group?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deletePipeGroup(editedPipeGroup)">Delete</button>
            </div>
        </div>
    </div>
</div>


<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addModal" (click)="prepareCreate()">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let pipeGroup of pipeGroupsGridData, let row_no = index">
        <td>{{pipeGroup.name}}</td>
        <td>{{pipeGroup.code}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(pipeGroup, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(pipeGroup, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class PipeGroupsGridComponent implements OnInit {
  isPipeGroupsHidden = true;
  pipeGroupsGridData: PipeGroupModel[];
  editedPipeGroup = new PipeGroupModel();
  rowNumber: number;
  public formGroup: FormGroup;
  headers: string[] = ['Name', 'Code', ''];

  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deletePipeGroupSubject.subscribe( (value) => {
      this.pipeGroupsGridData = this.pipeGroupsGridData.filter(x => x._id !== value);
    });
    this.createForm();
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllPipeGroups().subscribe((response) => {
      this.pipeGroupsGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isPipeGroupsHidden = !this.isPipeGroupsHidden;
  }

  saveNewPipeGroup() {
    this.mainPageService.addNewPipeGroupIntoDb(JSON.stringify(this.editedPipeGroup)).subscribe((response) => {
      this.editedPipeGroup._id = response._id;
      this.editedPipeGroup.id = response.id;
      this.pipeGroupsGridData.push(this.editedPipeGroup);
      this.editedPipeGroup = new PipeGroupModel();
    });
  }

  setChoosenElement(element, row) {
    this.editedPipeGroup = {
      ...element,
    };
    this.rowNumber = row;
    this.createForm();
  }

  editPipeGroup() {
    console.log(this.pipeGroupsGridData[this.rowNumber]);
    Object.assign(this.pipeGroupsGridData[this.rowNumber], this.editedPipeGroup);
    this.mainPageService.updatePipeGroupInDb(JSON.stringify(this.editedPipeGroup)).subscribe((response) => {});
  }

  deletePipeGroup(element) {
    this.mainPageService.removePipeGroup(element._id).subscribe((res) => {}, (error: any) => {});
    this.mainPageService.deletePipeGroupSubject.next(element._id);
  }

  public prepareCreate() {
    this.editedPipeGroup = new PipeGroupModel();
    this.createForm();
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.editedPipeGroup.name, Validators.required),
      code: new FormControl(this.editedPipeGroup.code),
      description: new FormControl(this.editedPipeGroup.description)
    });
  }
}
